<template>
    <div id="contenedor-main-auditoria">
      <v-container fluid>
        <v-card
          flat
          class="mb-4 rounded-lg">
          <v-card-text class="px-0 py-1">
            <titulo-tool-bar
              titulo="Informes"
              nombreRuta="auditorias"
              regresar>
              <template v-slot:end>
                <span class="subtitle-2 text--secondary">
                  {{ getAuditoria.nombre }}
                </span>
              </template>
              <template v-slot:opciones-derecha>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon>
                    <v-icon>
                      mdi-cog-outline
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense nav>
                  <v-list-item
                  @click="mostrarAuditoriaContratos = !mostrarAuditoriaContratos">
                  <v-list-item-icon class="mr-2">
                    <v-icon>
                      mdi-file-sign
                    </v-icon>
                  </v-list-item-icon>
                    <v-list-item-title>
                      Contratos
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                @click="mostrarAuditoriaSeguimientoArchivos = !mostrarAuditoriaSeguimientoArchivos">
                  <v-list-item-icon class="mr-2">
                    <v-icon>
                      mdi-file-download-outline
                    </v-icon>
                  </v-list-item-icon>
                    <v-list-item-title>
                      Seguimiento Recibido
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
            </v-menu>
            </template>
            </titulo-tool-bar>
            <v-toolbar flat dense>
              <v-spacer></v-spacer>
              <v-btn
                v-if="mixValidaScopesActions(1)"
                color="primary"
                rounded
                @click="mostrarAgregarInforme = !mostrarAgregarInforme">
                <v-icon left small>
                  mdi-plus
                </v-icon>
                Nuevo
              </v-btn>
            </v-toolbar>
          </v-card-text>
        </v-card>
        <v-card
          flat>
          <v-card-text>
            <!-- Loader -->
            <v-skeleton-loader
              v-if="$apollo.loading"
              type="table-heading, table-thead, table-tbody"
            ></v-skeleton-loader>
            <listado
              v-if="!$apollo.loading"
              :solo-lectura="soloLectura"
              :listadoInformes="getListadoInformesConTotales"
              >
            </listado>
          </v-card-text>
        </v-card>
      </v-container>
      <v-dialog
        v-if="!$apollo.loading && mostrarAgregarInforme"
        v-model="mostrarAgregarInforme"
        width="600px"
        persistent>
        <AgregarInforme
          :auditoria="getAuditoria"
          v-on:cerrar="mostrarAgregarInforme = !mostrarAgregarInforme">
        </AgregarInforme>
      </v-dialog>
      <v-dialog
        v-if="!$apollo.loading && mostrarAuditoriaContratos"
        v-model="mostrarAuditoriaContratos"
        width="900px"
        >
        <AuditoriaContratos
        v-on:cerrarVentanaAuditoriaContratos="mostrarAuditoriaContratos =
        !mostrarAuditoriaContratos">
        </AuditoriaContratos>
      </v-dialog>
      <v-dialog
        v-if="!$apollo.loading && mostrarAuditoriaSeguimientoArchivos"
        v-model="mostrarAuditoriaSeguimientoArchivos"
        width="1200px"
        persistent
        >
        <AuditoriaSeguimientoArchivos
        v-on:cerrar="mostrarAuditoriaSeguimientoArchivos =
        !mostrarAuditoriaSeguimientoArchivos"
        :idAuditoria="idAuditoria">

       </AuditoriaSeguimientoArchivos>
      </v-dialog>
    </div>
</template>
<script>
import AUDITORIAS_INFORMES_POR_AUDITORIA from '@/graphql/querys/administracion/auditorias/auditoriasInformesPorAuditoria.gql';
import AUDITORIA from '@/graphql/querys/administracion/auditorias/auditoria.gql';
import AgregarInforme from '@/components/administracion/auditorias/informes/Nuevo.vue';
import listado from '@/views/administracion/auditorias/auditoria/informes/listado/Main.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import AuditoriaContratos from '@/components/administracion/auditorias/contratos/Listado.vue';
import AuditoriaSeguimientoArchivos from '@/components/administracion/auditorias/observaciones/detalles/respuestas/seguimientoArchivos.vue';

export default {
  name: 'MainAuditoria',
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      idAuditoria: this.$route.params.idAuditoria,
      mostrarAgregarInforme: false,
      mostrarAuditoriaContratos: false,
      mostrarAuditoriaSeguimientoArchivos: false,
    };
  },
  components: {
    listado,
    AgregarInforme,
    TituloToolBar,
    AuditoriaContratos,
    AuditoriaSeguimientoArchivos,
  },
  apollo: {
    auditoria: {
      query: AUDITORIA,
      variables() {
        return {
          id: this.$route.params.idAuditoria,
        };
      },
    },
    auditoriasInformesPorAuditoria: {
      query: AUDITORIAS_INFORMES_POR_AUDITORIA,
      variables() {
        return {
          idAuditoria: this.$route.params.idAuditoria,
        };
      },
    },
  },
  computed: {
    getAuditoria() {
      if (!this.auditoria) return {};
      return this.auditoria;
    },
    mostrarLabelInformes() {
      if (this.$route.params.idInforme) return false;
      return true;
    },
    getInformes() {
      if (!this.auditoriasInformesPorAuditoria) return [];
      return this.auditoriasInformesPorAuditoria;
    },
    getListadoInformesConTotales() {
      return this.getInformes.map((informe) => {
        const fechaHoy = new Date();
        const fechaHoySinHora = `${fechaHoy.getFullYear()}/${fechaHoy.getMonth() + 1}/${fechaHoy.getDate()}`;
        let plazo = this.calcularDiferenciaEnDias(fechaHoySinHora,
          informe.fechaVencimiento) || 0;
        const color = this.getColorPlazo(plazo,
          new Date(`${informe.fechaVencimiento} 00:00:0`) - new Date(`${fechaHoySinHora} 00:00:0`));
        if (color === '#EF5350' && plazo !== 0) {
          plazo *= -1;
        }
        let totalDesglose = 0;
        informe.observaciones
          .map(({ detalles }) => {
            totalDesglose += detalles.length;
            return true;
          });
        let totalDesglosesEnviados = 0;
        informe.observaciones
          .map(({ detalles }) => {
            detalles.map(({ enviado }) => {
              if (enviado) {
                totalDesglosesEnviados += 1;
              }
              return true;
            });
            return true;
          });
        let totalDesglosesPorEnviar = 0;
        informe.observaciones
          .map(({ detalles }) => {
            detalles.map(({ enviado }) => {
              if (!enviado) {
                totalDesglosesPorEnviar += 1;
              }
              return true;
            });
            return true;
          });
        let totalObservaciones = 0;
        let totalObservacionesPorSolventar = 0;
        informe.observaciones
          .map((observacion) => {
            totalObservaciones += 1;
            if (observacion.estatus !== 'SOLVENTADA') {
              totalObservacionesPorSolventar += 1;
            }
            return true;
          });
        const colorPorSolventar = this
          .getColorPorSolventar(totalObservacionesPorSolventar, totalObservaciones);
        return {
          plazo,
          color,
          totalDesglose,
          totalDesglosesEnviados,
          totalDesglosesPorEnviar,
          totalObservaciones,
          totalObservacionesPorSolventar,
          colorPorSolventar,
          ...informe,
        };
      })
        .slice()
        .sort((a, b) => new Date(a.fechaRecepcion) - new Date(b.fechaRecepcion));
    },
  },
  methods: {
    getColorPorSolventar(totalPorSolventar, total) {
      if (totalPorSolventar > 0) return '#EF5350';
      if (total > 0 && totalPorSolventar === 0) return '#43BC82';
      return 'base5';
    },
    getColorPlazo(plazo, diferencia) {
      if (diferencia <= 0) return '#EF5350';
      if (!plazo) return 'base4';
      if (plazo === 0) return '#EF5350';
      if (plazo <= 7) return '#FFC955';
      return '#43BC82';
    },
    calcularDiferenciaEnDias(fechaInicio, fechaTermino) {
      const nuevaFechaInicio = new Date(`${fechaInicio} 00:00:0`);
      const nuevaFechaTermino = new Date(`${fechaTermino} 00:00:0`);
      const diferenciaMiliSegundos = Math.abs(nuevaFechaTermino - nuevaFechaInicio);
      const diferenciaDias = Math.ceil(diferenciaMiliSegundos / (1000 * 60 * 60 * 24));
      return (diferenciaDias);
    },
  },
};
</script>
